import { render, staticRenderFns } from "./IRAAccounts.vue?vue&type=template&id=b5fed7a0&scoped=true"
import script from "./IRAAccounts.vue?vue&type=script&lang=js"
export * from "./IRAAccounts.vue?vue&type=script&lang=js"
import style0 from "./IRAAccounts.vue?vue&type=style&index=0&id=b5fed7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fed7a0",
  null
  
)

export default component.exports